import React from 'react';
import { HashRouter, Switch, Route } from 'react-router-dom';
import Header from './Components/Header';
import Footer from './Components/Footer';
import ScavengerList from './Containers/ScavengerList';
import Main from './Containers/Main';
import LinkPage from './Containers/Shared/LinkPage';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

class App extends React.Component {

  render() {
    return (
      <div className="bg-black">
        <HashRouter>
          <Header />
          <Switch>
            <Route exact path="/" component={theHuntIsOn() ? ScavengerList : Main} />
            <Route path="/accessibility" component={this.Accessibility} />
            <Route path="/about" component={this.About} />
            <Route path="/privacy-policy" component={this.Privacy} />
          </Switch>
          <Footer />
        </HashRouter>
      </div>
    );
  }

  //accessibility 
  Accessibility = () => <LinkPage title="Accessibility" link="accessibility" />
  About = () => <LinkPage title="About Us" link="about" />
  Privacy = () => <LinkPage title="Privacy Policies" link="privacy-policy" />
}

// const startDate = new Date(2020, 9, 20, 17);
// const endDate = new Date(2020, 9, 21);

const theHuntIsOn = () => {
  // let now = Date.now();
  // return now > startDate && now < endDate;
  return false;
}

export default App;
